import React, { createContext, useState, useEffect, useContext } from 'react';
import { getSettings } from '../utils/api';

const SettingsContext = createContext();

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState({
        logo: '',
        address: '1042 Market St, Suite 400\nSan Francisco, CA 94103',
        phone: '+1 (415) 555-0192',
        email: 'hello@nocturne.agency',
        loading: true
    });

    useEffect(() => {
        const fetchSettings = async () => {
            const data = await getSettings();
            if (data) {
                setSettings({
                    logo: data.logo || '',
                    address: data.address || '1042 Market St, Suite 400\nSan Francisco, CA 94103',
                    phone: data.phone || '+1 (415) 555-0192',
                    email: data.email || 'hello@nocturne.agency',
                    loading: false
                });
            } else {
                setSettings(prev => ({ ...prev, loading: false }));
            }
        };
        fetchSettings();
    }, []);

    return (
        <SettingsContext.Provider value={settings}>
            {children}
        </SettingsContext.Provider>
    );
}

export function useSettings() {
    const context = useContext(SettingsContext);
    if (context === undefined) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
}
